// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ReceiptsService } from '../../receipts.service';
import { PingTerminal } from './receipt.actions';
import { RECEIPT_STATE_DEFAULT, ReceiptStateModel } from './receipt.model';

@State({ name: 'Receipt', defaults: RECEIPT_STATE_DEFAULT })
@Injectable()
export class ReceiptState {

  constructor(private receiptService: ReceiptsService) {
  }

  @Selector()
  static isConnected(state: ReceiptStateModel): ReceiptStateModel['isConnected'] {
    return state.isConnected;
  }

  @Action(PingTerminal)
  pingTerminal(ctx: StateContext<ReceiptStateModel>): void {
    this.receiptService.pingTerminal()
      .subscribe({
        next: res => {
          ctx.patchState({ isConnected: !res.error });
        },
        error: err => {
          ctx.patchState({ isConnected: false });
        }
      });
  }


}


